module.exports = __webpack_public_path__ + "static/media/fundo2.211d5632.JPG";